import React, { useState, useEffect, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  IconButton,
  TextField,
  InputAdornment,
  Tooltip,
  Dialog,
  Button,
  Checkbox
} from "@mui/material";
import toast from "react-hot-toast";
import { Select, MenuItem } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GetAppIcon from "@mui/icons-material/GetApp";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { URL } from "../config";

const InstallationList = () => {
   const { setLoading } = useOutletContext();
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [openMedia, setOpenMedia] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedTechnician, setSelectedTechnician] = useState("");
const [data, setData] = useState([]);
const [rowTechnicians, setRowTechnicians] = useState({});

const [statuses, setStatuses] = useState([]);
const [technicians, setTechnicians] = useState([]);
const [multiAssignMode, setMultiAssignMode] = useState(false); 
const [selectedRows, setSelectedRows] = useState([]); 


useEffect(() => {
  axios.get(`${URL}/technicians`)
    .then(res => {
      setTechnicians(res.data);
    })
    .catch(err => console.log(err));
}, []);


useEffect(() => {
  axios
    .get(`${URL}/statuses`)
    .then((res) => {
      setStatuses(res.data);
    })
    .catch((err) => console.log(err));
}, []);



  
const fetchInstallations = async () => {
  try {
    const response = await axios.get(`${URL}/installations/`);
    const installations = response.data.data;

    const finalData = await Promise.all(
      installations.map(async (item) => {
        let customerName = "N/A";
        let mobileNo = item.MobileNo || "N/A";
        let requestName = "N/A";

        try {
          const c = await axios.get(`${URL}/customers/${item.fkCustomerId}`);
          customerName = c.data?.CustomerName || "N/A";
        } catch (e) {}

        try {
          const r = await axios.get(`${URL}/requests/${item.fkrequestId}`);
          requestName = r.data?.requestName || "N/A";
        } catch (e) {}

        let photos = [];
        try {
          photos = Array.isArray(item.Photo)
            ? item.Photo
            : item.Photo
            ? JSON.parse(item.Photo)
            : [];
        } catch (err) {
          photos = [];
        }

        return {
          InstallationId: item.InstallationId,
          fkCustomerId: item.fkCustomerId,
          fkrequestId: item.fkrequestId,
          requestName,
          requestTitle: item.requestTitle || "N/A",
          CustomerName: customerName,
          MobileNo: mobileNo,
          Address: item.Address,
          latitude: item.latitude,
          longitude: item.longitude,
          Description: item.Description,
          Photo: photos,
          fktechnicianId: item.fktechnicianId || null,
          fkstatusId: item.fkstatusId || null,
        };
      })
    );

    
    setDataSource(finalData);

    
    setRowTechnicians((prev) => {
      const merged = { ...prev };
      finalData.forEach((item) => {
        if (item.fktechnicianId && !merged[item.InstallationId]) {
          merged[item.InstallationId] = item.fktechnicianId;
        }
      });
      return merged;
    });

  } catch (error) {
    console.error("Error fetching installations:", error);
  }
};


useEffect(() => {
  const initialFetch = async () => {
    setLoading(true);          
    await fetchInstallations();
    setLoading(false);
  };

  initialFetch();

 const interval = setInterval(() => {
  if (!multiAssignMode) fetchInstallations(); 
}, 5000);


  return () => clearInterval(interval);
}, []);



 
  const handleEdit = (id) => {
    navigate(`/dashboard/installation-form/${id}`);
  };

  const handleOpenMedia = (url) => {
    setSelectedMedia(url);
    setOpenMedia(true);
  };

  const handleCloseMedia = () => {
    setSelectedMedia(null);
    setOpenMedia(false);
  };


  const handleDownloadExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Installation List");

      worksheet.columns = [
        { header: "Sr No.", key: "InstallationId", width: 15 },
        { header: "Request Type", key: "fkrequestId", width: 15 },
        { header: "Customer Name", key: "CustomerName", width: 15 },
        { header: "Mobile No", key: "MobileNo", width: 20 },
        { header: "Address", key: "Address", width: 40 },
        { header: "Latitude", key: "latitude", width: 15 },
        { header: "Longitude", key: "longitude", width: 15 },
        { header: "Request Title", key: "requestTitle", width: 30 },
        { header: "Description", key: "Description", width: 50 },
      ];

      dataSource.forEach((item) => worksheet.addRow(item));
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "Installation_List.xlsx");
    } catch (err) {
      console.error("Excel export error:", err);
    }
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
    doc.setFontSize(18);
    doc.text("Installation List", 40, 40);

    const head = [[
      "Sr No.", 
      "Request Type",
      "Customer Name",
      "Mobile No",
      "Address",
      "Latitude",
      "Longitude",
      "Request Title",
      "Description"
    ]];

    const body = dataSource.map((item) => [
      item.InstallationId,
      item.fkrequestId,
      item.CustomerName,
      item.MobileNo,
      item.Address,
      item.latitude,
      item.longitude,
      item.requestTitle,
      item.Description
    ]);

    autoTable(doc, { startY: 60, head, body, headStyles: { fillColor: [23,66,83], textColor:"#fff" }, styles:{ fontSize:10, cellPadding:6 }, theme:"grid" });
    doc.save("Installation_List.pdf");
  };

  const handlePrint = () => {
    const tableRows = dataSource.map((item) => `
      <tr>
        <td>${item.InstallationId}</td>
        <td>${item.fkrequestId}</td>
        <td>${item.CustomerName}</td>
        <td>${item.MobileNo}</td>
        <td>${item.Address}</td>
        <td>${item.latitude}</td>
        <td>${item.longitude}</td>
        <td>${item.requestTitle}</td>
        <td>${item.Description}</td>
      </tr>
    `).join("");

    const style = `<style>
      @media print {@page { size: landscape; margin: 18mm; } body { -webkit-print-color-adjust: exact !important; }}
      table { width:100%; border-collapse: collapse; font-size:14px;}
      th { background:#174253; color:#fff; padding:10px; text-align:left; border-bottom:2px solid #174253; }
      td { padding:10px; border-top:1px solid #dcdcdc; border-bottom:1px solid #dcdcdc; }
      tr:nth-child(even) td { background:#f5f5f5; }
      h1 { text-align:center; color:#174253; margin-bottom:20px; font-size:22px; }
    </style>`;

    const html = `<html><head><title>Installation List</title>${style}</head>
      <body><h1>Installation List</h1>
        <table><thead><tr>
          <th>Sr No.</th><th>Request Type</th><th>Customer Name</th><th>Mobile No</th><th>Address</th>
          <th>Latitude</th><th>Longitude</th><th>Request Title</th><th>Description</th>
        </tr></thead>
        <tbody>${tableRows}</tbody>
      </table>
      </body></html>`;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(html);
    printWindow.document.close();
    setTimeout(() => printWindow.print(), 500);
  };
const handleAssign = async (row) => {
  const technicianId = rowTechnicians[row.InstallationId];

  if (!technicianId) {
    toast.error("Please select a technician first");
    return;
  }

  try {
 
    const formData = new FormData();
    formData.append("fktechnicianId", technicianId);

    
    await axios.patch(
      `${URL}/installations/assign/${row.InstallationId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Technician assigned");
    await fetchInstallations();

    setDataSource((prev) =>
      prev.map((item) =>
        item.InstallationId === row.InstallationId
          ? { ...item, fktechnicianId: technicianId }
          : item
      )
    );

    setRowTechnicians((prev) => ({
      ...prev,
      [row.InstallationId]: technicianId,
    }));

  } catch (error) {
    console.log(error);
    toast.error("Failed to assign technician");
  }
};


  const columns = useMemo(() => [
    {
  accessorKey: "Select",
  header: multiAssignMode ? "Select" : "",
  size: 50,
  Cell: ({ row }) => {
    if (!multiAssignMode) return null;
    if (row.original.fkstatusId === 5) return null;
    const checked = selectedRows.some(r => r.InstallationId === row.original.InstallationId);

    return (
     <Checkbox
  checked={selectedRows.some(r => r.InstallationId === row.original.InstallationId)}
  onChange={(e) => {
    if (e.target.checked) setSelectedRows(prev => [...prev, row.original]);
    else setSelectedRows(prev => prev.filter(r => r.InstallationId !== row.original.InstallationId));
  }}
  onClick={(e) => e.stopPropagation()}
/>

    );
  }
},
{
  accessorKey: "Location",
  header: "Location",
  size: 80,
  Cell: ({ row }) => {
    const { InstallationId, latitude, longitude } = row.original;
    if (!latitude || !longitude) return "N/A";

    return (
      <Tooltip title="View on Map">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation(); 
            navigate(`/dashboard/installation-map/${InstallationId}`);
          }}
        >
          <LocationOnIcon sx={{ color: "#174253" }} />
        </IconButton>
      </Tooltip>
    );
  },
}


,
    { accessorKey: "Actions", header: "Actions", size: 60, Cell: ({ row }) => (
   <Tooltip title="Assign Technician">
  <IconButton
    size="small"
    onClick={(e) => {
      e.stopPropagation(); 
      handleAssign(row.original);
    }}
  >
    <AssignmentTurnedInIcon sx={{ color: "#184459ff" }} fontSize="small" />
  </IconButton>
</Tooltip>



    )},
  
    { accessorKey: "InstallationId", header: "ID", size: 60 },
   {
  accessorKey: "Technician",
  header: "Technician",
  size: 160,
  Cell: ({ row }) => {
    const rowId = row.original.InstallationId;
    const isCompleted = row.original.fkstatusId === 5; 

    return (
      <Select
        fullWidth
        size="small"
        value={rowTechnicians[rowId] ?? ""}
        disabled={isCompleted}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation();
          setRowTechnicians((prev) => ({
            ...prev,
            [rowId]: e.target.value,
          }));
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 250,       
              width: "auto",        
              minWidth: 160,       
              maxWidth: 300,      
            },
          },
        }}
        sx={{
          height: "32px",
          fontSize: "14px",
          maxWidth: "160px",
          minWidth: "160px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: isCompleted ? "#d9d9d9" : "#bfbfbf",
          },
          "& .MuiSelect-select": {
            padding: "4px 10px !important",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            backgroundColor: isCompleted ? "#f5f5f5" : "white",
            cursor: isCompleted ? "not-allowed" : "pointer",
          },
        }}
      >
        {technicians.map((tech) => (
          <MenuItem
            key={tech.technicianId}
            value={tech.technicianId}
            sx={{
              fontSize: "14px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: 300, 
              "&:hover": {
                backgroundColor: "#f0f0f0",
                color: "black",
              },
              "&.Mui-selected": {
                backgroundColor: "#e6f4ff !important",
                color: "black",
              },
            }}
          >
            {tech.technicianName}
          </MenuItem>
        ))}
      </Select>
    );
  },
}
,
{
  accessorKey: "Status",
  header: "Status",
  size: 160,
  Cell: ({ row }) => {
    const statusId = row.original.fkstatusId;

    const status = statuses.find(s => s.statusId === statusId);

    const color = statusId === 5 ? "green" : "inherit"; 

    return (
      <span style={{ color, fontWeight: "600" }}>
        {status ? status.statusName : "N/A"}
      </span>
    );
  },
}

,
    { accessorKey: "requestName", header: "Request Name", size: 120 },
    { accessorKey: "requestTitle", header: "Request Title", size: 160 },
    { accessorKey: "CustomerName", header: "Customer Name", size: 180 },
    { accessorKey: "MobileNo", header: "Mobile No", size: 140 },
    { accessorKey: "Address", header: "Address", size: 200 },
    { accessorKey: "latitude", header: "Latitude", size: 120 },
    { accessorKey: "longitude", header: "Longitude", size: 120 },
    { accessorKey: "Description", header: "Description", size: 250, Cell: ({ row }) => (
      <span style={{ display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical", overflow:"hidden" }}>
        {row.original.Description}
      </span>
    )},
   {
  accessorKey: "Photo",
  header: "Photos/Videos",
  size: 200,
  Cell: ({ row }) => (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {row.original.Photo?.map((url, idx) => {
        const fullUrl = url.startsWith("/") ? `${URL}${url}` : url;
        const isVideo = /\.(mp4|webm|ogg)$/i.test(url);

        if (isVideo) {
          return (
            <video
              key={idx}
              src={fullUrl}
              style={{
                width: 50,
                height: 50,
                borderRadius: 5,
                cursor: "pointer",
                objectFit: "cover",
              }}
              onClick={(e) => {
                e.stopPropagation();      
                handleOpenMedia(fullUrl);
              }}
            />
          );
        }

        return (
          <img
            key={idx}
            src={fullUrl}
            alt="media"
            style={{
              width: 50,
              height: 50,
              objectFit: "cover",
              borderRadius: 5,
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();        
              handleOpenMedia(fullUrl);
            }}
          />
        );
      })}
    </Box>
  ),
}

  ],  [technicians, rowTechnicians, multiAssignMode, selectedRows]);

  return (
    <Box sx={{ width:"100%", bgcolor:"#ffffff", mt:2, p:{xs:1,md:0}, overflow:"hidden" }}>
      
       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, pr: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", fontWeight: 700, fontSize: 22, color: "#174253", letterSpacing: 0.5, borderLeft: "5px solid #174253", pl: 1.5 }}>
                Installation List
              </Box>
              <Button
  sx={{
    borderRadius: 25,
    background: "linear-gradient(90deg, #0b8793, #174253)",
    color: "white",
    "&:hover": { background: "linear-gradient(90deg, #174253, #0b8793)" },
  }}
  onClick={async () => {
    if (!multiAssignMode) {
      
      setMultiAssignMode(true);
      setSelectedRows([]);
      return;
    }

    if (selectedRows.length === 0) {
      toast.error("Select at least one row");
      return;
    }

  
    for (const row of selectedRows) {
      if (!rowTechnicians[row.InstallationId]) {
        toast.error(`Please select a technician for row ${row.InstallationId}`);
        return;
      }
    }

    try {
      
      for (const row of selectedRows) {
        const technicianId = rowTechnicians[row.InstallationId];
        const formData = new FormData();
        formData.append("fktechnicianId", technicianId);

        await axios.patch(`${URL}/installations/assign/${row.InstallationId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      toast.success("Technicians assigned successfully");

      
      await fetchInstallations();

      
      setMultiAssignMode(false);
      setSelectedRows([]);
    } catch (err) {
      console.error(err);
      toast.error("Failed to assign technicians");
    }
  }}
>
  {multiAssignMode ? "Assign Selected" : "Assign"}
</Button>

            </Box>

      
      <Box sx={{ background:"#fff", borderRadius:"0 0 15px 15px" }}>
        <div style={{ position:"relative", width:"100%", marginTop:"10px" }}>
          <div style={{ position:"absolute", top:10,right:20,left:20, display:"flex", justifyContent:"space-between", alignItems:"center", zIndex:2, marginBottom:10 }}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <Tooltip title="Download Excel">
                <IconButton onClick={handleDownloadExcel} sx={{ backgroundColor:"#d4f1d4", color:"#174253", "&:hover":{backgroundColor:"#b5e3b5"}}}><GetAppIcon/></IconButton>
              </Tooltip>
              <Tooltip title="Download PDF">
                <IconButton onClick={handleDownloadPDF} sx={{ backgroundColor:"#ffe2e2", color:"#d32f2f", "&:hover":{backgroundColor:"#ffcccc"}}}><PictureAsPdfIcon/></IconButton>
              </Tooltip>
              <Tooltip title="Print">
                <IconButton onClick={handlePrint} sx={{ backgroundColor:"#e3f2fd", color:"#174253", "&:hover":{backgroundColor:"#cde4fa"}}}><PrintIcon/></IconButton>
              </Tooltip>
            </div>
            <TextField
              size="small"
              placeholder="Search installations..."
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              InputProps={{ startAdornment:<InputAdornment position="start"><SearchIcon sx={{ color:"#174253" }}/></InputAdornment> }}
              sx={{ width:{xs:200,sm:250}, "& .MuiOutlinedInput-root":{ borderRadius:25, height:38, backgroundColor:"#fff", boxShadow:"0 0 6px rgba(0,0,0,0.1)", "& fieldset":{borderColor:"#d0d7de"}, "&:hover fieldset":{borderColor:"#174253"} } }}
            />
          </div>
        </div>

        <MaterialReactTable
  columns={columns}
  data={
    [...dataSource] 
      .reverse()    
      .filter(item =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(globalFilter.toLowerCase())
      )
  }

  enablePagination={true}

  initialState={{
    pagination: {
      pageSize: 100, 
      pageIndex: 0,
    },
  }}

  muiPaginationProps={{
    rowsPerPageOptions: [10, 25, 50, 100],
    showFirstButton: true,
    showLastButton: true,
  }}

  enableColumnActions={false}
  enableDensityToggle={false}
  enableFullScreenToggle={false}
  enableColumnFilters={false}
  enableHiding={false}
  enableGlobalFilter={false}

  muiTablePaperProps={{
    sx: {
      boxShadow: "none",
      background: "#fff",
      borderRadius: "15px",
    },
  }}

  muiTableContainerProps={{
    sx: {
      backgroundColor: "#fff",
      width: "100%",
      overflowX: "auto",
      borderRadius: "12px",
      "&::-webkit-scrollbar": { height: "6px" },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#e0e3ea",
        borderRadius: "10px",
      },
    },
  }}

  muiTableHeadCellProps={{
    sx: {
      backgroundColor: "#e0e0e0ff",
      color: "#393e4f",
      fontWeight: 600,
      fontSize: "16px",
      borderBottom: "0.5px solid #e3e5eb",
      borderRight: "none",
      borderLeft: "none",
      textAlign: "left",
      height: "63px",
      paddingTop: "23px",
      marginTop: "15px",
    },
  }}

  muiTableBodyRowProps={({ row }) => ({
    onClick: () => {
      const id = row.original?.InstallationId;
      if (id) {
        navigate(`/dashboard/installation-detailpage/${id}`);
      } else {
        console.error("ID not found in row.original");
      }
    },
    sx: {
      cursor: "pointer",
      backgroundColor: "#fff",
      "&:hover": { backgroundColor: "#eff6fe" },
      "& td": {
        fontSize: { xs: "12px", sm: "14px" },
        p: "8px",
        borderBottom: "0.5px solid #e3e5eb",
        borderRight: "none",
        borderLeft: "none",
        height: "54px",
      },
    },
  })}
/>

      </Box>

     
      <Dialog open={openMedia} onClose={handleCloseMedia} maxWidth="lg">
        <Box sx={{ position:"relative" }}>
          <IconButton onClick={handleCloseMedia} sx={{ position:"absolute", top:8, right:8, color:"#000", zIndex:10 }}><CloseIcon/></IconButton>
          {selectedMedia && /\.(mp4|webm|ogg)$/i.test(selectedMedia) ? (
            <video src={selectedMedia} controls autoPlay style={{ maxWidth:"90vw", maxHeight:"80vh" }}/>
          ) : (
            <img src={selectedMedia} alt="media" style={{ maxWidth:"90vw", maxHeight:"80vh" }}/>
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default InstallationList;
